/**
 * ArmSCII-8 decoding for the PDF text layer of legacy-font pages (source "legacy_map"): pdf.js
 * sees the font's byte values as Latin-1 ("Ñ³Ù³ñ"), the server stores the decoded text
 * ("համար"). A copy of packages/extract/src/legacy/armscii8.ts (the web image is built from
 * apps/web alone); armscii8.test.ts checks that both decode every character the same way.
 */
const PUNCTUATION: Record<number, string> = {
  0xa0: " ",
  0xa1: "֎",
  0xa2: "և",
  0xa3: "։",
  0xa4: ")",
  0xa5: "(",
  0xa6: "»",
  0xa7: "«",
  0xa8: "—",
  0xa9: "․",
  0xaa: "՝",
  0xab: ",",
  0xac: "‐",
  0xad: "֊",
  0xae: "…",
  0xaf: "՜",
  0xb0: "՞",
  0xb1: "՛",
  0xfe: "՚",
  0xff: "՟",
};

const TABLE: string[] = [];
for (let code = 0; code < 256; code += 1) {
  if (code >= 0xb2 && code <= 0xfd) {
    const index = code - 0xb2;
    const base = index % 2 === 0 ? 0x0531 : 0x0561;
    TABLE[code] = String.fromCharCode(base + Math.floor(index / 2));
  } else {
    TABLE[code] = PUNCTUATION[code] ?? String.fromCharCode(code);
  }
}

/** Characters that Unicode compatibility normalization produces from Latin-1 bytes. */
const FOLDED: Record<string, number> = { μ: 0xb5 };

/** Decodes text whose characters U+0080-U+00FF are ArmSCII-8 bytes; everything else is kept. */
export function decodeArmscii8(text: string): string {
  let out = "";
  for (const ch of text) {
    let code = ch.charCodeAt(0);
    if (code < 0x80 || code > 0xff) {
      const folded = FOLDED[ch];
      if (folded === undefined) {
        out += ch;
        continue;
      }
      code = folded;
    }
    out += TABLE[code] ?? ch;
  }
  return out;
}
